import { render, staticRenderFns } from "./ShopCustomers.vue?vue&type=template&id=4e4f1664&"
import script from "./ShopCustomers.vue?vue&type=script&lang=js&"
export * from "./ShopCustomers.vue?vue&type=script&lang=js&"
import style0 from "./ShopCustomers.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports